import React, {useEffect, useState} from 'react'
import {Modal, Button} from 'react-bootstrap'
import close_icon from '../../assets/images/icons/close-icon.png'
import tick_icon from '../../assets/images/icons/tick-icon.png'
import {resetPassword} from '../../actions'
import {useDispatch, useSelector} from 'react-redux'
import { RESET_PASSWORD_LOADING_ID } from '../../store/loaders'



import ModelInput from '../inputText/modelInput';
import SubmitButton from '../loadingButton/modelSubmitButton';
import CancelButton from '../loadingButton/modelCancelButton';
import NotificationMessage from '../notificationMessage'




function SetPasswordModel(props) {

  const dispatch = useDispatch()

  const apiResponse = useSelector(state=>{
    const {loader, resetPassword} = state
    const {isLoading} = loader[RESET_PASSWORD_LOADING_ID] || {isLoading: false}
    const {status} = resetPassword
    return{
      isLoading,
      status
    }
  })


  const actionLoader = apiResponse.isLoading

    const [email, setEmail] = useState('')
    const [status, setStatus] = useState('')


  


    useEffect(()=>{
      if(apiResponse.status?.description){
        setStatus(apiResponse.status?.description)
      }
    },[apiResponse.status])

    const handleResetpassword = () =>{
        dispatch(resetPassword(email))
    } 

    const handleCloseNotificationMessage = ()=>{
      setStatus('')
    }
    return (
      <> 
        <Modal 
          show={props.show} 
          onHide={()=>{props.hide();handleCloseNotificationMessage()}}
          centered
          size="lg">
          {props.changeView ?<div className="model-body">
            <div className="d-flex model-title">
              <span>Set your password</span>
              <div 
                className="d-flex close-ctn"
                onClick={props.hide}>
                  <span>close</span>
                  <img src={close_icon}/>
              </div>
            </div>
            <br/>
          { status !== '' && 
            <NotificationMessage
              signinStatus={status}
              handleCloseNotificationMessage={handleCloseNotificationMessage}
              style={{margin: 'auto', backgroundColor: '#ccc', width: '95%'}}
            /> }
            <br/>
            <div className="input-fields-ctn">
                  <ModelInput
                    title="Enter your Email"
                    value={email}
                    type="email"
                    handleChange={(text)=>setEmail(text.target.value)}
                    />
            </div>
            <div className="model-footer-buttons">
              <CancelButton
                title="CANCEL"
                submit={()=>{props.hide(); setStatus('')}}/>
              <SubmitButton
                title="SUBMIT"
                submit={handleResetpassword}
                disabled={actionLoader}/>
            </div>
          </div> : 
          <div className="model-body">
            <div className="d-flex model-title" style={{padding: 20}}></div>
            <div className="success-model-body-content">
              <img src={tick_icon}/>

              <span 
                className="thank-you-text"
                style={{padding: '20px 0px'}}>
                    Thank You</span>
              <span 
                className="thank-you-description"
                style={{padding: '20px 0px'}}>
                    Thank You! Your password has been updated.</span>
              <Button
                onClick={props.hide} 
                className="model-accept-button"
                variant="light"
                style={{
                  border: '2px solid #979797',
                  marginTop: 20
                }}>
                  <span>
                      OK
                  </span>
              </Button>
            </div>
          </div>
          }
        </Modal>
      </>
    );
  }
  
export default SetPasswordModel